import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop 組件
 *
 * 當路由改變時自動滾動到頁面頂部
 * 這是 React Router v6 的標準做法
 *
 * 使用方式：
 * 將此組件放在 Router 內部，但在 Routes 外部
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // 使用 instant 行為立即跳轉到頂部，無動畫
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
    }, [pathname]);

    return null;
};

export default ScrollToTop;
